import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ArrIconButton from '../../../../common/arr-icon-button/ArrIconButton';
import {SessionSearch} from '../../../types/SessionSearch';

export interface NewItemProps {
  index: number;
  item: SessionSearch;
  onDelete?: (index: number, item: SessionSearch) => void;
}

const NewItem: React.FC<NewItemProps> = ({index, item, onDelete}) => {
  const handleButtonClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onDelete && onDelete(index, item);
  };

  const handleOnButtonKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.code === 'Enter') {
      e.stopPropagation();
      onDelete && onDelete(index, item);
    }
  };

  return (
    <Stack direction="row">
      <Box className="label-container">
        <Typography
          className="typo-text subhead5_size"
          data-testid={`new-item-name-${index}`}
          title={item.name}
        >
          {item.name}
        </Typography>
      </Box>
      {item?.name !== 'Search 1' && (
        <Box className="icon-button-container">
          <ArrIconButton
            icon={<ClearIcon />}
            onClick={handleButtonClick}
            onKeyDown={handleOnButtonKeyDown}
            ariaLabel="Remove"
            shape="none"
            size="small"
            tooltipContent="Remove"
            tooltipPlacement="top"
            tooltipTrigger="hover"
            className="icon-clear"
            testId={`list-item-${index}-clear`}
          />
        </Box>
      )}
    </Stack>
  );
};
export default NewItem;
